var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEmptyIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "52px",
    viewBox: "0 0 45 52",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681.000000, -295.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Book,-fairy-tale",
    transform: "translate(681.000000, 295.000000)",
    fill: "#0b3d7f",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.999865,0 C4.0297903,0 0,3.8805 0,8.66645 L0,43.33355 C0,48.1195 4.0297903,52 8.999865,52 L45,52 C41.2732877,48.4094 41.2732877,42.58865 45,39 L45,0 L8.999865,0 Z M37.9050041,47.66645 L8.999865,47.66645 C6.51449014,47.66645 4.499595,45.72685 4.499595,43.33355 C4.499595,40.94025 6.51449014,39 8.999865,39 L39.4433444,39 C37.9232292,41.6702 37.4156242,44.72975 37.9050041,47.66645 Z M40.500405,34.66645 L8.999865,34.66645 C7.35217352,34.66645 5.82733327,35.1234 4.499595,35.86895 L4.499595,8.66645 C4.499595,6.27315 6.51449014,4.33355 8.999865,4.33355 L40.500405,4.33355 L40.500405,34.66645 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 25,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 15,
    height: 5
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty-icon.b49651ed.svg";
export { ForwardRef as ReactComponent };